var touVars = {
  LAST_UPDATED: "May 29, 2026", // e.g. "March 15, 2026"
  STORE_NAME: "The Mecum Shop", // e.g. "BNP Paribas Open Shop"
  CORPORATE_NAME: "The Mecum Shop", // e.g. "Legends Global Merchandise, LLC"
  CS_EMAIL: "mecumshop@lgmretail.com", // e.g. "support@store.com" — used as mailto: href and link text
  PRIVACY_NOTICE_URL: "/pages/privacy-notice", // e.g. "/pages/privacy-notice"
  RETURNS_POLICY_URL: "/pages/cancellations-returns-policy", // e.g. "/pages/shipping-returns"
};

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-tou-var]").forEach(function (el) {
    var key = el.getAttribute("data-tou-var");
    var val = touVars[key];
    if (!val) return; // leave fallback text/href intact if not configured
    if (el.tagName === "A") {
      el.href = key === "CS_EMAIL" ? "mailto:" + val : val;
      el.textContent = key === "CS_EMAIL" ? val : el.textContent;
    } else {
      el.textContent = val;
    }
  });
});
(function () {
  function openAncestorDetails(hash) {
    if (!hash) return;
    var target = document.getElementById(hash.replace(/^#/, ""));
    if (!target) return;
    var el = target.parentElement;
    while (el && el !== document.body) {
      if (el.tagName === "DETAILS") el.open = true;
      el = el.parentElement;
    }
    requestAnimationFrame(function () {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }
  if (window.location.hash) {
    setTimeout(function () {
      openAncestorDetails(window.location.hash);
    }, 50);
  }
  window.addEventListener("hashchange", function () {
    openAncestorDetails(window.location.hash);
  });
})();
